import React from 'react';
import _isNil from 'lodash/isNil';
import { useIntl, defineMessages } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { SurveyTotalResponseResult } from '../../../Surveys/util/SurveyResponseResults';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Box } from '@lifeomic/chroma-react/components/Box';

const messages = defineMessages({
  sum: {
    id: 'SurveyTotals.sum',
    defaultMessage: 'Survey Sum: {value}',
  },
  avg: {
    id: 'SurveyTotals.avg',
    defaultMessage: 'Survey Average: {value}',
  },
});

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('xl')]: {
      maxWidth: theme.pxToRem(1200),
    },
  },
  totalMessage: {
    marginRight: theme.spacing(4),
    paddingBottom: theme.spacing(2.5),
  },
}));

export type SurveyTotalsOwnProps = {
  surveyTotal: SurveyTotalResponseResult;
};

export type SurveyTotalsProps = SurveyTotalsOwnProps;

const SurveyTotals: React.FC<SurveyTotalsProps> = ({ surveyTotal }) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});

  if (_isNil(surveyTotal?.avg) && _isNil(surveyTotal?.sum)) return null;

  const elements: React.ReactElement[] = [];
  if (!_isNil(surveyTotal?.avg)) {
    elements.push(
      <Text
        size="body"
        weight="bold"
        key="avg"
        className={classes.totalMessage}
      >
        {formatMessage(messages.avg, { value: surveyTotal.avg })}
      </Text>,
    );
  }

  if (!_isNil(surveyTotal?.sum)) {
    elements.push(
      <Text
        size="body"
        weight="bold"
        key="sum"
        className={classes.totalMessage}
      >
        {formatMessage(messages.sum, { value: surveyTotal.sum })}
      </Text>,
    );
  }

  return <Box className={classes.root}>{elements}</Box>;
};

export default React.memo(SurveyTotals);
